export enum CheckoutStep {
  OrderInfo = 0,
  BillingInfo = 1,
  PatientInfo = 2,
  ClinicalHistory = 3,
  ConsentInfo = 4,
  ConfirmOrder = 5,
}
